<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		name: 'App',
		mounted() {
			
		}
	}
</script>


// WEBPACK FOOTER //
// src/App.vue